import React from "react";
import globalVariables from "GlobalVariable";
import { useNavigate } from "react-router-dom";

export default function PlanExpiredNotice() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col justify-center items-center bg-white">
      <div className="mb-8">
        <img src="https://samedaypet.s3.amazonaws.com/ba4faeb5-cc14-4e69-8846-204001c9f41f.png" alt="Logo" width={300} />
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-lg w-96">
        <div className="flex flex-col gap-6 text-center">
          <h1 className="text-2xl font-bold text-gray-800">
            Your Plan Has Expired
          </h1>

          <p className="text-gray-700 text-base">
            Please renew your subscription or contact us at{" "}
            <a
              href="mailto:info@azucarmultimedia.com"
              className="text-orange-500 hover:text-orange-600 font-semibold"
            >
              info@azucarmultimedia.com
            </a>
          </p>

          <button
            onClick={() => navigate("/services-plans")}
            className="w-full text-white font-bold rounded-full p-2 bg-orange-500 hover:bg-orange-600 transition-colors"
          >
            Renew Now
          </button>
        </div>
      </div>
    </div>
  );
}
